// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomMenu__wrapper--39m","link":"BottomMenu__link--LSD","icon":"BottomMenu__icon--231"};